<template>
  <div>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-if="data">
      <v-layout class="m-0" row wrap>
        <v-flex xs12 class="mb-2">
          <label>ชื่อ - นามสกุล</label>
          <div style="word-break: break-word">{{ `${data.firstname} ${data.lastname}` }}</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <label>เพศ</label>
          <div style="word-break: break-word">-</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <label>เบอร์โทรศัพท์</label>
          <div style="word-break: break-word">{{ data.sms || '-' }}</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <label>อีเมล</label>
          <div style="word-break: break-word">{{ data.email || '-' }}</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <label>Hospital Number</label>
          <div style="word-break: break-word">{{ data.hn || '-' }}</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <label>Consult</label>
          <div style="word-break: break-word">{{ data.consult || '-' }}</div>
        </v-flex>
      </v-layout>
      <v-divider class="my-3" />
      <v-layout class="m-0" row wrap>
        <div class="primary--text">ช่องทาง</div>
        <v-flex xs12 class="mt-2">
          <div><em class="fab fa-facebook-square" style="color: #3b5998" /> Facebook</div>
          <div style="word-break: break-word">ID -</div>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <div><em class="fab fa-line" style="color: #00c300" /> Line</div>
          <div style="word-break: break-word">{{ data.line || '-' }}</div>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <div class="text-center">ไม่พบข้อมูล</div>
    </template>
    <v-divider class="my-3" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    data: {
      value: undefined
    },
    userid: {
      value: undefined
    },
    pageid: {
      value: undefined
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/DrMekCDPProfile.vue